var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { hasMany, belongsTo, attr } from '@ember-data/model';
import { isEmpty } from '@ember/utils';
import { deprecate } from '@ember/debug';
import { findBy } from 'ilios-common/utils/array-helpers';
let School = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = hasMany('competency', {
  async: true,
  inverse: 'school'
}), _dec6 = hasMany('course', {
  async: true,
  inverse: 'school'
}), _dec7 = hasMany('program', {
  async: true,
  inverse: 'school'
}), _dec8 = hasMany('vocabulary', {
  async: true,
  inverse: 'school'
}), _dec9 = hasMany('instructor-group', {
  async: true,
  inverse: 'school'
}), _dec10 = belongsTo('curriculum-inventory-institution', {
  async: true,
  inverse: 'school'
}), _dec11 = hasMany('session-type', {
  async: true,
  inverse: 'school'
}), _dec12 = hasMany('user', {
  async: true,
  inverse: 'directedSchools'
}), _dec13 = hasMany('user', {
  async: true,
  inverse: 'administeredSchools'
}), _dec14 = hasMany('school-config', {
  async: true,
  inverse: 'school'
}), _class = class School extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "templatePrefix", _descriptor2, this);
    _initializerDefineProperty(this, "iliosAdministratorEmail", _descriptor3, this);
    _initializerDefineProperty(this, "changeAlertRecipients", _descriptor4, this);
    _initializerDefineProperty(this, "competencies", _descriptor5, this);
    _initializerDefineProperty(this, "courses", _descriptor6, this);
    _initializerDefineProperty(this, "programs", _descriptor7, this);
    _initializerDefineProperty(this, "vocabularies", _descriptor8, this);
    _initializerDefineProperty(this, "instructorGroups", _descriptor9, this);
    _initializerDefineProperty(this, "curriculumInventoryInstitution", _descriptor10, this);
    _initializerDefineProperty(this, "sessionTypes", _descriptor11, this);
    _initializerDefineProperty(this, "directors", _descriptor12, this);
    _initializerDefineProperty(this, "administrators", _descriptor13, this);
    _initializerDefineProperty(this, "configurations", _descriptor14, this);
  }
  get cohorts() {
    deprecate(`school.cohorts is called, don't use this.`, false, {
      id: 'common.school-cohorts',
      for: 'ilios-common',
      until: '63',
      since: '62.0.1'
    });
    return this.store.query('cohort', {
      filters: {
        schools: [this.id]
      }
    });
  }
  async getConfigByName(name) {
    const configs = await this.configurations;
    const config = findBy(configs, 'name', name);
    return isEmpty(config) ? null : config;
  }
  async getConfigValue(name) {
    const config = await this.getConfigByName(name);
    if (!config) {
      return null;
    }
    return config.parsedValue;
  }
  async setConfigValue(name, value) {
    const oldValue = await this.getConfigValue(name);
    if (value !== oldValue) {
      let config = await this.getConfigByName(name);
      if (isEmpty(config)) {
        config = await this.createConfig(name);
      }
      config.set('value', value);
      return config;
    }
    return false;
  }
  async createConfig(name) {
    const store = this.store;
    const config = store.createRecord('school-config', {
      school: this,
      name
    });
    const configurations = await this.configurations;
    configurations.push(config);
    return config;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "templatePrefix", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "iliosAdministratorEmail", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "changeAlertRecipients", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "competencies", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "courses", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "programs", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "vocabularies", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "instructorGroups", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "curriculumInventoryInstitution", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "sessionTypes", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "directors", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "administrators", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "configurations", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { School as default };